/**
 * @generated SignedSource<<0ee3fc0b087fe2c3def8f9a4d3e8bceb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SingleSelectFieldOptionFragment$data = {
  readonly color: ProjectV2SingleSelectFieldOptionColor;
  readonly name: string;
  readonly nameHTML: string;
  readonly optionId: string;
  readonly " $fragmentType": "SingleSelectFieldOptionFragment";
};
export type SingleSelectFieldOptionFragment$key = {
  readonly " $data"?: SingleSelectFieldOptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldOptionFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "SingleSelectFieldOptionFragment"
};

(node as any).hash = "4604df55cb617656d7b398c0179206b7";

export default node;
